import React, { Fragment, FunctionComponent } from "react";
import BoxWrapProps from "./BoxWrapProps.interface";

import BoxWrap1 from "./blocks/BoxWrap1/BoxWrap1";
import BoxWrap2 from "./blocks/BoxWrap2/BoxWrap2";

const BOX_WRAP_TYPES: { [key: string]: any } = {
    "nestedBoxWrap1": BoxWrap1,
    "nestedBoxWrap2": BoxWrap2
};

// eslint-disable-next-line react/display-name
const BoxWrap: FunctionComponent<BoxWrapProps> = React.forwardRef<HTMLDivElement, BoxWrapProps>((props, ref) => {
    const contentType = props?.content?._contentType;

    if (!contentType) {
        return (
            <div className={props.className} ref={ref}>{props.children}</div>
        );
    }

    const DynamicBoxWrap = BOX_WRAP_TYPES[contentType];

    return (
        <Fragment>
            {DynamicBoxWrap && props ? (
                <DynamicBoxWrap {...props} ref={ref} />
            ) : null}
        </Fragment>
    );
});

export default BoxWrap;